// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import type { ComponentInterface } from '@stencil/core'
import { AttachInternals, Component, h } from '@stencil/core'

/**
 * The `<qds-table>` element represents tabular data — that is, information
 * presented in a two-dimensional table comprised of rows and columns of cells
 * containing data.
 *
 * @see https://quartz.se.com/build/components/table
 */
@Component({
  tag: 'qds-table',
  shadow: true,
  styleUrl: 'table.css',
})
export class Table implements ComponentInterface {
  @AttachInternals() private readonly internals!: ElementInternals

  public componentWillLoad(): void {
    this.internals.role = 'table'
  }

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this
  public render() {
    return <slot />
  }
}
